export const IntermediaryTransferTrigger = (props) => {
  const { sellerOptions, transferTo, onOpenIntermediaryModal, onClearTransferTo } =
    props;

  const selectedTransferSeller = sellerOptions?.find(
    (seller) => seller?._id === transferTo
  );
  const hasSellerOptions = sellerOptions?.length > 0;

  if (!selectedTransferSeller && !hasSellerOptions) {
    return null;
  }

  return (
    <div className="col-12">
      {!selectedTransferSeller && hasSellerOptions && (
        <button
          type="button"
          className="intermediary-transfer-button intermediary-transfer-button-change"
          onClick={onOpenIntermediaryModal}
        >
          <span className="intermediary-transfer-button-icon">⇄</span>
          Cambiar a intermediario
        </button>
      )}
      {selectedTransferSeller && (
        <div className="intermediary-transfer-selected">
          <button
            type="button"
            className="intermediary-transfer-selected-label"
            onClick={onOpenIntermediaryModal}
          >
            {`TRASPASO A ${selectedTransferSeller?.name}`}
          </button>
          <button
            type="button"
            className="intermediary-transfer-selected-clear"
            onClick={onClearTransferTo}
          >
            x
          </button>
        </div>
      )}
    </div>
  );
};
